import * as CONST from './constants';
import checkStateLoading from 'helpers/checkStateLoading';

export const initialState = {
  loyaltyReport: {
    error: null,
    loading: false,
    payload: {
      totalCustomerLoggedIn: {
        delta: 0,
        value: 0,
      },
      existingCustomer: {
        delta: 0,
        value: 0,
      },
      newCustomerEnrolled: {
        delta: 0,
        value: 0,
      },
      customerEnrollmentRate: {
        delta: 0,
        value: 0,
      },
      
      openingPoints: {
        delta: 0,
        value: 0,
      },
      earnedPoints: {
        delta: 0,
        value: 0,
      },
      redeemedPoints: {
        delta: 0,
        value: 0,
      },
      pointsExpired: {
        delta: 0,
        value: 0,
      },
      closingPoints: {
        delta: 0,
        value: 0,
      },
      pointsConverted: {
        delta: 0,
        value: 0,
      },
      avgPointsEarn: {
        delta: 0,
        value: 0,
      },
      avgPointsRedeem: {
        delta: 0,
        value: 0,
      },

      customers: {
        loyal: 0,
        non: 0,
      },
      sales: {
        loyal: 0,
        non: 0,
      },
      orders: {
        loyal: 0,
        non: 0,
      },
      visit: {
        loyal: 0,
        non: 0,
      },
      spend: {
        loyal: 0,
        non: 0,
      },
      abv: {
        loyal: 0,
        non: 0,
      },
      earn: [],
      burn: []
    },
  },
  loyaltyTrend: {
    error: null,
    loading: false,
    payload: [],
  },
  isReady: false,
};

function loyaltyReducer(state = initialState, action) {
  const { type, payload, error } = action;
  let newState;
  switch (type) {
    case CONST.FETCH_LOYALTY_REPORT_ACTION:
      return {
        ...state,
        loyaltyReport: {
          error: null,
          loading: true,
          payload: state.loyaltyReport.payload,
        },
        isReady: false,
      };

    case CONST.FETCH_LOYALTY_REPORT_SUCCESS_ACTION:
      newState = {
        ...state,
        loyaltyReport: {
          error: null,
          loading: false,
          payload,
        },
      };
      return {
        ...newState,
        isReady: !checkStateLoading(newState),
      };

    case CONST.FETCH_LOYALTY_REPORT_ERROR_ACTION:
      newState = {
        ...state,
        loyaltyReport: {
          error,
          loading: false,
          payload: state.loyaltyReport.payload,
        },
      };
      return {
        ...newState,
        isReady: !checkStateLoading(newState),
      };

    case CONST.FETCH_LOYALTY_TREND_ACTION:
      return {
        ...state,
        loyaltyTrend: {
          error: null,
          loading: true,
          payload: state.loyaltyTrend.payload,
        },
        isReady: false,
      };

    case CONST.FETCH_LOYALTY_TREND_SUCCESS_ACTION:
      newState = {
        ...state,
        loyaltyTrend: {
          error: null,
          loading: false,
          payload,
        },
      };
      return {
        ...newState,
        isReady: !checkStateLoading(newState),
      };

    case CONST.FETCH_LOYALTY_TREND_ERROR_ACTION:
      newState = {
        ...state,
        loyaltyTrend: {
          error,
          loading: false,
          payload: state.loyaltyTrend.payload,
        },
      };
      return {
        ...newState,
        isReady: !checkStateLoading(newState),
      };

    default:
      return state;
  }
}

export default loyaltyReducer;
